import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { CommonService } from '../../../services/common.service';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SelectOptionPipe } from '../../../pipes/select-option.pipe';



@Component({
    selector: 'app-form-select',
    templateUrl: './form-select.component.html',
    styleUrls: ['form-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatFormField, ReactiveFormsModule, NgClass, MatLabel, MatInput, MatError, MatAutocompleteTrigger, MatAutocomplete, MatOption, TranslateModule, SelectOptionPipe]
})
export class FormSelectComponent implements Field, OnInit {
  config: FieldConfig;
  group: FormGroup;
  FormControlName: string;
  iosSelectOptionDisable: boolean;
  options = [];
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;
  constructor(private _commonService: CommonService) {

  }
  ngOnInit() {
    this.FormControlName = this.config.name;
    this.iosSelectOptionDisable = this.config.iosDisableSelect ? this.config.iosDisableSelect : false;
    this.group.controls[this.config.name].setValue(this.config.value);
  }

  reset(event) {
    if (this.group.controls[this.config.name].value === '') {
      event.target.blur();
      this.group.controls[this.config.name].setValue(this.config.value);
    }
  }

  onChange(event){
    this.config.changeEvent && this.config.changeEvent(event);
  }

  displayFn(id: any) {
    try {
      if(this.autocompleteTrigger) {
        this._commonService.autoComplete = this.autocompleteTrigger;
      }
      let index = this.config?.options?.findIndex(x => x.id === id);
      return this.config?.options[index]?.value;
    } catch (error) {
      console.log('error occured selected Customer', error);
    }
  }

  validInput(event) {
    this.config.isValidForm && this.config.isValidForm(event);
  }



}

